import type {TierApiModel} from '../../../api/gamification';
import type {Nullable} from '../../utility-types';

export const getTierImage = (tier?: Nullable<TierApiModel>) => {
  if (!tier) {
    return require('../../../assets/gamification/tiers/tier-1.png');
  }

  switch (tier.level) {
    case 1:
      return require('../../../assets/gamification/tiers/tier-1.png');
    case 2:
      return require('../../../assets/gamification/tiers/tier-2.png');
    case 3:
      return require('../../../assets/gamification/tiers/tier-3.png');
    case 4:
      return require('../../../assets/gamification/tiers/tier-4.png');
    case 5:
      return require('../../../assets/gamification/tiers/tier-5.png');
    case 6:
      return require('../../../assets/gamification/tiers/tier-6.png');
    case 7:
      return require('../../../assets/gamification/tiers/tier-7.png');
    default:
      return require('../../../assets/gamification/tiers/tier-1.png');
  }
};
